import React, { useEffect, useState } from 'react'
import { inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import { Grid, Icon, Loader, Table } from 'semantic-ui-react'
import Section from '../../UI/Section'
import { Time } from '../../misc/Times'
import OcBotTestCreateModal from './OcBotTestCreateModal'

const OcBotTestTable = ({ store, actions, history }) => {
  const [conversations, setConversations] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const load = async() => {
    setLoading(true)
    setError(null)
    const [result, err] = await actions.admin.listOcBotTestConversations()
    setLoading(false)
    if(err) {
      setError('Error fetching OC bot test conversations')
      return
    }
    setConversations(result)
  }

  useEffect(() => {
    load()
  }, [])

  const onCreated = (conversationId) => {
    history.push(`/admin/ocBotTest/${conversationId}`)
  }

  return (
    <div className='content' id='ocBotTest'>
      <div className='content-body'>
        <Section>
          <OcBotTestCreateModal store={store} actions={actions} onCreated={onCreated}/>
          <Loader active={loading}/>
          <Table celled striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Id</Table.HeaderCell>
                <Table.HeaderCell>White label</Table.HeaderCell>
                <Table.HeaderCell>Bot persona</Table.HeaderCell>
                <Table.HeaderCell>Simulated user</Table.HeaderCell>
                <Table.HeaderCell>Premium</Table.HeaderCell>
                <Table.HeaderCell>Messages</Table.HeaderCell>
                <Table.HeaderCell>Updated</Table.HeaderCell>
                <Table.HeaderCell>Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {conversations.map((conversation) => (
                <Table.Row key={conversation.id} style={{ cursor: 'pointer' }} onClick={() => history.push(`/admin/ocBotTest/${conversation.id}`)}>
                  <Table.Cell>{conversation.id}</Table.Cell>
                  <Table.Cell>{conversation.whiteLabelUid}</Table.Cell>
                  <Table.Cell>{conversation.user0Profile.username}</Table.Cell>
                  <Table.Cell>{conversation.user1Profile.username}</Table.Cell>
                  <Table.Cell>{conversation.isPremium ? 'Yes' : 'No'}</Table.Cell>
                  <Table.Cell>{conversation.messages.length}</Table.Cell>
                  <Table.Cell>
                    <Time time={conversation.updatedAt * 1000}/>
                  </Table.Cell>
                  <Table.Cell>
                    <Icon name='eye' title='View conversation' style={{ cursor: 'pointer' }}/>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
          <Grid centered={true}>
            <Grid.Column style={{ display: 'flex', justifyContent: 'center' }}>
              {error && <h4>{error}</h4>}
              {!loading && !error && conversations.length === 0 && <p>No OC bot test conversations yet.</p>}
            </Grid.Column>
          </Grid>
        </Section>
      </div>
    </div>
  )
}

export default inject('store', 'actions')(withRouter(OcBotTestTable))
